import Modal from 'react-bootstrap/Modal'
import { t } from '../locale'
import { Button, FormControl, Row } from 'react-bootstrap'
import { useState } from 'react'
import v from '../validators'
import { Form } from 'react-bootstrap'

function KAccess(props: any) {
    const [pinCode, setPinCode] = useState(props.pin || '');
    const [isValidPin, setIsValidPin] = useState(true);

    function handlePin(event: React.ChangeEvent<HTMLInputElement>) {
        const value = event.target.value;
        setPinCode(value);
        setIsValidPin(v.pinCode(value));
    }

    function onClick() {
        if (typeof props.onConfirm === 'function') {
            props.onConfirm(pinCode);
        }
    }

    return (

        <Modal id='token' show={props.show} centered >
            <Modal.Header>
                <h4 className="modal-title">Two factor auth</h4>
                <Button className='btn-close' data-bs-dismiss="modal" aria-label="Close"></Button>

            </Modal.Header>
            <Modal.Body>
                <p className="alert alert-success smaller">{props.title}</p>

                <Form className='needs-validation' noValidate>
                    <div className="col-12 col-md-6 mx-auto">
                        <div className='form-floating mb-2'>
                            <FormControl
                                id='pinCode'
                                isInvalid={!isValidPin}
                                value={pinCode}
                                onChange={handlePin}
                                autoComplete='off'
                                autoFocus
                                required
                            />
                            <Form.Label htmlFor="pinCode" className="small">Pin Code</Form.Label>
                        </div>
                    </div>
                    <div className="col-12 mx-auto">
                        <hr className="my-4" />
                        <Row className='gx-2'>
                            <div className="col-12 text-end">
                                <Button
                                    id='btn-confirm-proceed'
                                    variant='success'
                                    className='f-right text-white'
                                    onClick={onClick}
                                >{t('submit')}</Button>
                            </div>
                        </Row>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>

    );
}

export default KAccess;